/* global axios */
import ApiClient from '../ApiClient';

class ChamadosAPI extends ApiClient {
  constructor() {
    super('support_tickets', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  // Número do ícone Chamados no menu: { count, tone }.
  news() {
    return axios.get(`${this.url}/news`);
  }

  // Chamado aberto na tela recebeu novidade: quem está olhando já viu.
  seen(id) {
    return axios.post(`${this.url}/${id}/seen`);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(formData) {
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  update(id, formData) {
    return axios.patch(`${this.url}/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  // Resposta do cliente no fio do chamado (bidirecional, plano §3.5).
  // Multipart: aceita arquivos/áudio gravado além do texto.
  comment(id, { body = '', files = [] } = {}) {
    const formData = new FormData();
    formData.append('body', body);
    files.forEach(file => formData.append('attachments[]', file));
    return axios.post(`${this.url}/${id}/comments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  approve(id, { approvalNote = '' } = {}) {
    return axios.patch(`${this.url}/${id}/approve`, {
      approval_note: approvalNote,
    });
  }

  reject(id, { approvalNote }) {
    return axios.patch(`${this.url}/${id}/reject`, {
      approval_note: approvalNote,
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new ChamadosAPI();
